export const VIDEO_BLOG_INDEX = {
	en: {
		pageTitle: "TU | Video blogs",
		metaDescription:
			"Technical video blogs on hydraulics, pneumatics, electrical, and mechanical industrial topics.",
		metaKeywords: "blogs, TU, hydraulic, mechanical, exports, electrical",
		ogTitle: "TU | Video blogs",
		ogDescription:
			"Industrial video blogs on hydraulics, pneumatics, electrical, and mechanical topics.",
		ogUrl: "https://www.tu.biz/en/video-blogs",
		ogImage:
			"https://www.tu.biz/video-blog-images-english/blog-index-english.png",
		twitterTitle: "TU | Video blogs",
		twitterDescription:
			"Video blogs about hydraulics, electrical, mechanical, and industrial topics.",
		title: "Video blogs",
		intro:
			"Technical tutorials and explanations for hydraulics, electrical, and mechanical systems.",
		searchPlaceholder: "Search videos…",
		searchTitle: "Search by title",
		readMore: "Watch video",
		emptyResults: "No videos match your search.",
		resultsLabel: (n) => `${n} video${n === 1 ? "" : "s"}`,
	},
	es: {
		pageTitle: "TU | Video blog industrial",
		metaDescription:
			"Video blogs industriales sobre hidráulica, neumática, electricidad y mecánica.",
		metaKeywords: "blogs, español, industrial, hidráulica, mecánica, eléctrica",
		ogTitle: "TU | Video blog industrial",
		ogDescription:
			"Video blogs sobre hidráulica, neumática, electricidad, mecánica y más.",
		ogUrl: "https://www.tu.biz/es/video-blog",
		ogImage:
			"https://www.tu.biz/video-blog-images-spanish/blog-index-spanish.png",
		twitterTitle: "TU | Video blog industrial",
		twitterDescription:
			"Video blogs sobre temas industriales, hidráulica, neumática, electricidad y mecánica.",
		title: "Video blog",
		intro:
			"Tutoriales y explicaciones técnicas en hidráulica, electricidad y sistemas mecánicos.",
		searchPlaceholder: "Buscar videos…",
		searchTitle: "Buscar por título",
		readMore: "Ver video",
		emptyResults: "No hay videos que coincidan con su búsqueda.",
		resultsLabel: (n) => `${n} video${n === 1 ? "" : "s"}`,
	},
};
